module.exports = __webpack_public_path__ + "img/galeria-captores-6.c6ac32ce.png";